import React from "react"

import { RichtextStoryblok } from "@/components/storyblok/component-types"
import UbRichText from "@/components/storyblok/UbRichText"

interface LegalConsentCheckboxProps {
  onChange: any
  text: RichtextStoryblok | undefined
  showRequired: boolean | undefined
  requiredText: string | undefined
}

export default function LegalConsentCheckbox(props: LegalConsentCheckboxProps) {
  return (
    <div className="flex flex-row items-start gap-2 text-xs">
      <input
        id={"legal_consent"}
        aria-label={"legal_consent"}
        className={"checked:bg-primary hover:checked:bg-primary focus:ring-0"}
        name={"legalConsent"}
        type="checkbox"
        onChange={props.onChange}
      />
      <label htmlFor={"legal_consent"}>
        <div className={"flex flex-col gap-2"}>
          {props.text && (
            <div>
              <UbRichText blok={{ content: props.text, _uid: "", component: "ub_rich_text" }} />
            </div>
          )}
          <div>{props.showRequired && <p className={"text-xs text-red-500"}>{props.requiredText}</p>}</div>
        </div>
      </label>
    </div>
  )
}
